import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Dimmer } from "../components/spinner";
import { TableBody, TableRow, TableCell } from "@mui/material";
import axios from "axios";
import useTableScroll from "../components/useTableScrollcesar.js";
const op = require("../modulos/datos.js");

const CatalogoDesincorporacionMueble = ({ show, onHide }) => {
  const token = localStorage.getItem("jwtToken");
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtCodigo = useRef([]);
  const txtBuscar = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [lista, setLista] = useState([]);
  const [todos, setTodos] = useState([]);
  let values = {
    iddesincorporacionmueble: "",
    codigobien: "",
    descripcion: "",
    seriales: "",
    placa: "",
    idincorporacionmueble: "",
  };

  const headCells = [
    { label: "Id. Bien", textAlign: "center" },
    { label: "Cod. Bien", textAlign: "center" },
    { label: "Tipo Activo", textAlign: "center" },
    { label: "Seriales", textAlign: "center" },
    { label: "Placa", textAlign: "center" },
    { label: "Id", textAlign: "center" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);
  const handleSearch = (e) => {
    let target = e.target;
    let lista = [];

    if (target.value === "") {
      lista = todos;
    } else {
      lista = todos.filter((x) => {
        if (
          x.iddesincorporacionmueble.includes(target.value) ||
          x.idincorporacionmueble.includes(target.value) ||
          x.codigobien.toLowerCase().includes(target.value.toLowerCase()) ||
          x.descripcion.toLowerCase().includes(target.value.toLowerCase())
        ) {
          return x;
        }
      });
    }

    setLista(lista);
  };

  const seleccionarRegistros = () => {
    const campos =
      "desincorporacionmueble.iddesincorporacionmueble, codigobien, TRIM(descripcion) as descripcion, TRIM(seriales) as seriales, TRIM(placa) as placa, desincorporacionmueble.idincorporacionmueble";
    const nomtab = "desincorporacionmueble";
    const nomid = "idincorporacionmueble";
    const nomtab2 = "incorporacionmueble";
    const nomid2 = "idtipoactivo";
    const nomtab3 = "tipoactivo";
    const orden = "iddesincorporacionmueble";

    const endpoint = `${op.conexion}/api/consulta/seleccionarregistros9?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&nomtab2=${nomtab2}&nomid2=${nomid2}&nomtab3=${nomtab3}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setLista(response.data);
            setTodos(response.data);
          } else {
            setLista([]);
            setTodos([]);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setLista([]);
    setTodos([]);
    values = {
      iddesincorporacionmueble: "",
      codigobien: "",
      descripcion: "",
      seriales: "",
      placa: "",
      idincorporacionmueble: "",
    };
  };

  const seleccionarFila = (item, index) => {
    values = {
      iddesincorporacionmueble: item.iddesincorporacionmueble,
      codigobien: item.codigobien,
      descripcion: item.descripcion,
      seriales: item.seriales,
      placa: item.placa,
      idincorporacionmueble: item.idincorporacionmueble,
    };

    for (let i = 0; i < txtCodigo.current.length; i++) {
      if (i === index) {
        txtCodigo.current[i].style.backgroundColor = "lightskyblue";
      } else {
        if (txtCodigo.current[i]) {
          txtCodigo.current[i].style.backgroundColor = "white";
        }
      }
    }

    btnAcepta.current.focus();
  };

  const cancelar = () => {
    blanquear();
    onHide();
  };

  const seleccionar = () => {
    onHide(values);
  };

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.8)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        seleccionarRegistros();
        txtBuscar.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Catalogo de Desincorporacion de Bienes Muebles</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} />
        <div className="row col-md-12" style={{ marginBottom: "10px" }}>
          <div className="input-group m-0 col-md-6 input-group-sm mb-3">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control text-uppercase"
              ref={txtBuscar}
            />
            <button className="btn btn-info" style={{ pointerEvents: "none" }}>
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer
            container={{
              height: 200,
              width: "100%",
              overflow: "auto",
              padding: "2px",
              fontSizeAdjust: "0.6",
            }}
          >
            <TblHead />

            <TableBody>
              {lista &&
                lista.map((item, index) => (
                  <TableRow
                    key={index}
                    ref={(el) => (txtCodigo.current[index] = el)}
                    style={{ backgroundColor: "white" }}
                    onClick={() => seleccionarFila(item, index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.idincorporacionmueble}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.codigobien}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.descripcion}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.seriales}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.placa}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.iddesincorporacionmueble}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          className="btn btn-sm btn-success rounded-pill"
          style={{ margin: "5px" }}
          onClick={seleccionar}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoDesincorporacionMueble;
